import { render } from "./ModalCreateEditPriceList.vue?vue&type=template&id=363d6c8c&scoped=true"
import script from "./ModalCreateEditPriceList.vue?vue&type=script&lang=js"
export * from "./ModalCreateEditPriceList.vue?vue&type=script&lang=js"

import "./ModalCreateEditPriceList.vue?vue&type=style&index=0&id=363d6c8c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363d6c8c"]])

export default __exports__